// Formulaciones aceptadas por Sebastián el 28 de septiembre de 2026.
// Mantener en concordancia con docs/identidad-mipae.md y la guía editorial.
// La visión expresa una aspiración, no un resultado demostrado.
export const IDENTIDAD_MIPAE = {
  eslogan: "MiPAE, tu compañero en enfermería.",
  proposito: "Contribuir a un mejor cuidado de las personas, acompañando a enfermería mientras aprende, trabaja y cuida.",
  mision: "Fortalecer la capacidad de enfermería para gestionar el cuidado, poniendo a su alcance conocimiento y herramientas que le ayuden a aprender, fundamentar sus decisiones y mejorar su práctica.",
  vision: "Ser la inteligencia artificial de referencia para la enfermería en el mundo, reconocida por fortalecer su capacidad de gestionar el cuidado.",
  valores: [
    {
      nombre: "Claridad",
      descripcion: "Hacemos comprensible el conocimiento y facilitamos su aplicación al cuidado. Diseñamos herramientas fáciles de utilizar y explicamos sus alcances y límites.",
    },
    {
      nombre: "Rigor y confianza",
      descripcion: "Fundamentamos los contenidos, reconocemos la incertidumbre y corregimos los errores. Protegemos la información que se nos confía y comunicamos nuestros avances y resultados con honestidad.",
    },
    {
      nombre: "Empatía",
      descripcion: "Reconocemos a las personas detrás del aprendizaje y del cuidado. Escuchamos sus necesidades, respetamos su tiempo y consideramos su bienestar en las decisiones que tomamos.",
    },
    {
      nombre: "Autonomía profesional",
      descripcion: "Fortalecemos la capacidad de comprender, fundamentar y decidir. Promovemos el aprendizaje activo y preservamos el control de las personas sobre su trabajo y las decisiones de cuidado.",
    },
    {
      nombre: "Adaptabilidad",
      descripcion: "Respondemos a distintas etapas de formación, roles y contextos de ejercicio. Ajustamos nuestras herramientas a las necesidades de las personas y los equipos, respetando las particularidades de cada entorno.",
    },
    {
      nombre: "Innovación con enfermería",
      descripcion: "Construimos soluciones junto a quienes aprenden, ejercen, enseñan y gestionan el cuidado. Partimos de problemas reales, evaluamos la utilidad de lo que desarrollamos y mejoramos con la experiencia y la evidencia.",
    },
  ],
};
